/**
 * @file 获取app版本号
 */
import inBox from './is-in-app';

const UA = typeof window === 'object' && window.self === window ? navigator.userAgent : '';

/**
 * 获取App的版本号
 * @function getAppVersion
 * @param {string} ua - 传入的 userAgent，如果不传则取 navigator.userAgent
 * @return {string} version 返回app的版本号
 * @example
 * getAppVersion() // 1.0.0
 */

export default (ua = UA) => {
    if (typeof window === 'object' && window.fcapp_version) {
        return window.fcapp_version;
    }
    let version = '0';
    if (inBox(ua)) {
        const match = /fcapp\/([\d.]+)/.exec(ua);
        version = match ? match[1] : version;
    }
    return version;
};
